import { useMemo } from "react";
import {
  MaterialReactTable,
  MRT_EditActionButtons,
  useMaterialReactTable,
} from "material-react-table";
import AppConfig from "../../config";
import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
// import { tab } from "@testing-library/user-event/dist/tab";

import FileDownloadIcon from "@mui/icons-material/FileDownload";

const DynamicTable = ({
  columns,
  data,
  totalSitesCount = data.length,
  pagination = { pageIndex: 0, pageSize: data.length },
  setPagination = () => {},
  isEnablePagination = false,
  isFilterEnable = false,
  isSearchBarEnable = false,
  headerBackgroundColor = AppConfig.colorPalette.primary.main,
  isEnableSorting = false,
  isHeaderBackgroundColor = true,
  showTableTopToolbar = false,
  enableColumnActions = false,
  color = isHeaderBackgroundColor ? "#fff" : "#000",
  iconHoverColor = isEnableSorting ? "#000" : "#fff",
  filterSearchBackground = isEnableSorting
    ? null
    : AppConfig.colorPalette.primary.main,
  filterSearchTextColor = isEnableSorting ? "#000" : "#fff",
  FilterSearchPlaceHolderText = AppConfig.colorPalette.text.disabled,
  filterSearchBorderColor = isEnableSorting ? "#000" : "#fff",
  filterSearchBorderHoverColor = isEnableSorting ? "#000" : "#fff",
  isLoading = false,
  enableEditing = false,
  headings = [],
  handleDeleteClick,
  handleEditData,
  updatingData = false,
  HeadingFontSize = "0.8rem",
  enableRowSelection = false,
  TopToolBar = () => {},
  updateRowSelection = () => {},
  rowSelection = 0,
  columnFilters = [],
  setColumnFilters = () => {},
  isRefetching = false,

  isServerSideFiltering = false,
}) => {
  const memoizedColumns = useMemo(() => columns, [columns]);
  const memoizedData = useMemo(() => data, [data]);
  const states = {
    pagination,
    isLoading,
    columnOrder: headings,
    isSaving: updatingData,
    showProgressBars: isRefetching,
    ...(isServerSideFiltering && { columnFilters: columnFilters }),
  };

  const table = useMaterialReactTable({
    columns: memoizedColumns,
    data: memoizedData,
    manualPagination: isEnablePagination,
    manualFiltering: isServerSideFiltering,
    state: isEnablePagination
      ? enableRowSelection
        ? { ...states, rowSelection }
        : states
      : undefined,
    isLoading,
    isSaving: updatingData,
    columnOrder: headings,
    rowCount: totalSitesCount,
    enablePagination: isEnablePagination,
    enableColumnFilters: isFilterEnable,
    enableGlobalFilter: isSearchBarEnable,
    enableSorting: isEnableSorting,
    enableColumnActions: enableColumnActions,
    enableEditing: enableEditing,
    enableRowActions: enableEditing,
    onEditingRowSave: ({ row, values, table }) => {
      handleEditData({ row, values, table });
    },
    enableRowSelection: enableRowSelection,

    onRowSelectionChange: updateRowSelection,
    ...(isServerSideFiltering && {
      onColumnFiltersChange: setColumnFilters,
    }),
    onPaginationChange: setPagination,
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: isHeaderBackgroundColor ? headerBackgroundColor : null,
        fontSize: HeadingFontSize,
        color: color + "!important",
        "& .MuiTableSortLabel-root": {
          color: color + "!important",
        },
        "& .MuiTableSortLabel-root:hover": {
          color: iconHoverColor + "!important",
        },
        "& .MuiTableSortLabel-icon": {
          color: color + "!important",
        },
        "& .MuiTableSortLabel-active .MuiTableSortLabel-icon": {
          color: `${iconHoverColor} !important`,
        },
        "& .MuiIconButton-root": {
          color: color + "!important",
        },
        "& .MuiIconButton-root:hover": {
          color: iconHoverColor + "!important",
        },
        "& .MuiInputBase-root": {
          backgroundColor: filterSearchBackground + "!important",
          color: filterSearchTextColor + "!important",
          borderColor: filterSearchBorderColor + "!important",
          "& .MuiOutlinedInput-notchedOutline": {},
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: filterSearchBorderHoverColor + "!important",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: filterSearchBorderHoverColor + "!important",
          },
        },
      },
    },
    muiTableHeadProps: {
      sx: {},
    },
    muiTopToolbarProps: {
      sx: {
        display: showTableTopToolbar ? "flex" : "none",
        overflowX: "auto",
        // justifyContent: "flex-end",
      },
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: "flex",
          // justifyContent: "flex-end",
          width: "100%",
        }}
      >
        <TopToolBar table={table} />
      </Box>
    ),

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "nowrap" }}>
        <IconButton onClick={() => table.setEditingRow(row)}>
          <EditIcon />
        </IconButton>
        <IconButton onClick={() => handleDeleteClick(row.original)}>
          <DeleteIcon sx={{ color: "#ff0000", marginRight: "8px" }} />
        </IconButton>
      </Box>
    ),

    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => {
      return enableEditing ? (
        <>
          <DialogTitle variant="h4">Edit Data</DialogTitle>
          <DialogContent
            sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}
          >
            {internalEditComponents}{" "}
          </DialogContent>
          <DialogActions>
            <MRT_EditActionButtons variant="text" table={table} row={row} />
          </DialogActions>
        </>
      ) : null;
    },
  });

  return <MaterialReactTable table={table} />;
};

export default DynamicTable;
